import { Routes, Route } from "react-router-dom";
import Layout from "./components/Layout";

// страницы
import Home from "./pages/home/home.jsx";
import AppsPage from "./pages/apps/AppsPage.jsx";
import AppDetail from "./pages/apps/AppDetail.jsx";
import NotesparkPrivacy from "./pages/apps/notespark/privacy.jsx";
import WhitenoisePrivacy from "./pages/apps/whitenoise/privacy";
import MagicEraserPrivacy from "./pages/apps/magicerace/privacy";
import QRBarcodePrivacy from "./pages/apps/qrbarcode/privacy";
import SmartGpsPrivacy from "./pages/apps/smartgps/privacy";
import NolaPrivacy from "./pages/apps/Nola/privacy.jsx";
import BrainIqTestPrivacy from "./pages/apps/BrainIQ/privacy.jsx";
import AiCollagePrivacy from "./pages/apps/Collage_Ai/privacy.jsx";
import SmartCaloriePrivacy from "./pages/apps/Colorie_Counter/privacy.jsx";
import AiHomeworkPrivacy from "./pages/apps/HWsolver/privacy.jsx";
import SmartInvoicePrivacy from "./pages/apps/Invoice_maker/privacy.jsx";
import VeilifyPrivacy from "./pages/apps/Photo_vaylt/privacy.jsx";
import PureTrackerVapingPrivacy from "./pages/apps/PureTrackerVaping/privacy.jsx";
import PureTrackerDrinkingPrivacy from "./pages/apps/PureTrackerDrinking/privacy.jsx";
import PupversePrivacy from "./pages/apps/pupverse/privacy.jsx";
import SchedulaPrivacy from "./pages/apps/Schedula/privacy.jsx";
import SeekAiChatPrivacy from "./pages/apps/seekaichat/privacy.jsx";
import SmartSpyPrivacy from "./pages/apps/Smart_spy/privacy.jsx";
import VoiceChangerPrivacy from "./pages/apps/Voice_changer/privacy.jsx";
import WishFlowPrivacy from "./pages/apps/WishFlow/privacy.jsx";
import TraderLabPrivacy from "./pages/apps/Trader_lab/privacy.jsx";


import BrainIQTerms from "./pages/apps/BrainIQ/termofuse.jsx";
import SmartCollageAiTerms from "./pages/apps/Collage_Ai/termofuse.jsx";
import AiCalorieCounterTerms from "./pages/apps/Colorie_Counter/termofuse.jsx";
import InvoiceMakerForContractorsTerms from "./pages/apps/Invoice_maker/termofuse.jsx";
import MagicEraserAiTerms from "./pages/apps/magicerace/termofuse.jsx";
import NolaAiChatFriendTerms from "./pages/apps/Nola/termofuse.jsx";
import NoteSparkTerms from "./pages/apps/notespark/termofuse.jsx";
import VeilifyPhotoVaultTerms from "./pages/apps/Photo_vaylt/termofuse.jsx";
import QRBarcodeScannerTerms from "./pages/apps/qrbarcode/termofuse.jsx";
import SchedulaTerms from "./pages/apps/Schedula/termofuse.jsx";
import SeekAiChatTerms from "./pages/apps/seekaichat/termofuse.jsx";
import SmartSpyDetectorTerms from "./pages/apps/Smart_spy/termofuse.jsx";
import SmartGpsCompassTerms from "./pages/apps/smartgps/termofuse.jsx";
import TraderLabTerms from "./pages/apps/Trader_lab/termofuse.jsx";
import VoiceChangerProTerms from "./pages/apps/Voice_changer/termofuse.jsx";
import WhiteNoiceCalmSleepTerms from "./pages/apps/whitenoise/termofuse.jsx";
import WishFlowTerms from "./pages/apps/WishFlow/termofuse.jsx";
import AiHomeworkSolverTerms from "./pages/apps/HWsolver/termofuse.jsx";
import PureTrackerQuitVapingTerms from "./pages/apps/PureTrackerVaping/termofuse.jsx";
import PureTrackerQuitDrinkingTerms from "./pages/apps/PureTrackerDrinking/termofuse.jsx";
import PupverseTerms from "./pages/apps/pupverse/termofuse.jsx";
import BrainIQAccountRemove from "./pages/apps/BrainIQ/accountremove.jsx";
import SmartCollageAiAccountRemove from "./pages/apps/Collage_Ai/accountremove.jsx";
import AiCalorieCounterAccountRemove from "./pages/apps/Colorie_Counter/accountremove.jsx";
import AiHomeworkSolverAccountRemove from "./pages/apps/HWsolver/accountremove.jsx";
import InvoiceMakerForContractorsAccountRemove from "./pages/apps/Invoice_maker/accountremove.jsx";
import MagicEraserAccountRemove from "./pages/apps/magicerace/accountremove.jsx";
import NolaAiChatFriendAccountRemove from "./pages/apps/Nola/accountremove.jsx";
import NoteSparkAccountRemove from "./pages/apps/notespark/accountremove.jsx";
import VeilifyPhotoVaultAccountRemove from "./pages/apps/Photo_vaylt/accountremove.jsx";
import PureTrackerQuitDrinkingAccountRemove from "./pages/apps/PureTrackerDrinking/accountremove.jsx";
import PureTrackerQuitVapingAccountRemove from "./pages/apps/PureTrackerVaping/accountremove.jsx";
import PupverseAccountRemove from "./pages/apps/pupverse/accountremove.jsx";
import QRBarcodeScannerAccountRemove from "./pages/apps/qrbarcode/accountremove.jsx";
import SchedulaAccountRemove from "./pages/apps/Schedula/accountremove.jsx";
import SeekAiChatAccountRemove from "./pages/apps/seekaichat/accountremove.jsx";
import SmartGpsCompassAccountRemove from "./pages/apps/smartgps/accountremove.jsx";
import SmartSpyDetectorAccountRemove from "./pages/apps/Smart_spy/accountremove.jsx";
import TraderLabAccountRemove from "./pages/apps/Trader_lab/accountremove.jsx";
import VoiceChangerProAccountRemove from "./pages/apps/Voice_changer/accountremove.jsx";
import WhiteNoiseCalmSleepAccountRemove from "./pages/apps/whitenoise/accountremove.jsx";
import WishFlowAccountRemove from "./pages/apps/WishFlow/accountremove.jsx";

import SupportPage from "./pages/support/index.jsx";
import PrivacyIndex from "./pages/PrivacyIndex.jsx";
import TermIndex from "./pages/TermIndex.jsx";
import AccountRemoveIndex from "./pages/AccountRemoveIndex.jsx";
import GradientBackground from "./pages/home/GradientBackground.jsx";
import homeStyles from "./styles/home.module.css";

function LegalIndexPage({ type }) {
  if (type === "privacy") {
    return (
      <>
        <GradientBackground />
        <div className={homeStyles.homeMainBox}>
          <PrivacyIndex />
        </div>
      </>
    );
  }

  if (type === "accountremove") {
    return (
      <>
        <GradientBackground />
        <div className={homeStyles.homeMainBox}>
          <AccountRemoveIndex />
        </div>
      </>
    );
  }

  return (
    <>
      <GradientBackground />
      <div className={homeStyles.homeMainBox}>
        <TermIndex />
      </div>
    </>
  );
}


function App() {
  return (
    <Layout>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/apps" element={<AppsPage />} />
        <Route path="/apps/:slug" element={<AppDetail />} />
        <Route path="/privacy" element={<LegalIndexPage type="privacy" />} />
        <Route path="/terms" element={<LegalIndexPage type="terms" />} />
        <Route path="/accountremove" element={<LegalIndexPage type="accountremove" />} />

        {/* Политика конфиденциальности */}
        <Route path="/apps/notespark/privacy" element={<NotesparkPrivacy />} />
        <Route path="/apps/magicerace/privacy" element={<MagicEraserPrivacy />} />
        <Route path="/apps/qrbarcode/privacy" element={<QRBarcodePrivacy />} />
        <Route path="/apps/smartgps/privacy" element={<SmartGpsPrivacy />} />
        <Route path="/apps/whitenoise/privacy" element={<WhitenoisePrivacy />} />

        <Route path="/apps/seekaichat/privacy" element={<SeekAiChatPrivacy />} />
        <Route path="/apps/Nola/privacy" element={<NolaPrivacy />} />
        <Route path="/apps/hwsolver/privacy" element={<AiHomeworkPrivacy />} />
        <Route path="/apps/photo_vaylt/privacy" element={<VeilifyPrivacy />} />
        <Route path="/apps/voice_changer/privacy" element={<VoiceChangerPrivacy />}/>

        <Route path="/apps/colorie_counter/privacy" element={<SmartCaloriePrivacy />} />
        <Route path="/apps/invoice_maker/privacy" element={<SmartInvoicePrivacy />} />
        <Route path="/apps/smart_spy/privacy" element={<SmartSpyPrivacy />} />
        <Route path="/apps/collage_ai/privacy" element={<AiCollagePrivacy />} />
        <Route path="/apps/Trader_lab/privacy" element={<TraderLabPrivacy />} />

        <Route path="/apps/wishflow/privacy" element={<WishFlowPrivacy />} />
        <Route path="/apps/brainiq/privacy" element={<BrainIqTestPrivacy />} />
        <Route path="/apps/puretrackervaping/privacy" element={<PureTrackerVapingPrivacy />} />
        <Route path="/apps/puretrackerdrinking/privacy" element={<PureTrackerDrinkingPrivacy />} />
        <Route path="/apps/pupverse/privacy" element={<PupversePrivacy />} />
        <Route path="/apps/schedula/privacy" element={<SchedulaPrivacy />} />

        {/* Условия использования */}

        <Route path="/apps/whitenoise/termofuse" element={<WhiteNoiceCalmSleepTerms />} />
        <Route path="/apps/qrbarcode/termofuse" element={<QRBarcodeScannerTerms />} />
        <Route path="/apps/smartgps/termofuse" element={<SmartGpsCompassTerms />} />
        <Route path="/apps/notespark/termofuse" element={<NoteSparkTerms />} />
        <Route path="/apps/magicerace/termofuse" element={<MagicEraserAiTerms />} />

        <Route path="/apps/seekaichat/termofuse" element={<SeekAiChatTerms />} />
        <Route path="/apps/Nola/termofuse" element={<NolaAiChatFriendTerms />} />
        <Route path="/apps/HWsolver/termofuse" element={<AiHomeworkSolverTerms />} />
        <Route path="/apps/Photo_vaylt/termofuse" element={<VeilifyPhotoVaultTerms />} />
        <Route path="/apps/Voice_changer/termofuse" element={<VoiceChangerProTerms />} />

        <Route path="/apps/Colorie_Counter/termofuse" element={<AiCalorieCounterTerms />} />
        <Route path="/apps/Invoice_maker/termofuse" element={<InvoiceMakerForContractorsTerms />} />
        <Route path="/apps/Smart_spy/termofuse" element={<SmartSpyDetectorTerms />} />
        <Route path="/apps/Collage_Ai/termofuse" element={<SmartCollageAiTerms />} />
        <Route path="/apps/Trader_lab/termofuse" element={<TraderLabTerms />} />
        
        <Route path="/apps/WishFlow/termofuse" element={<WishFlowTerms />} />
        <Route path="/apps/BrainIQ/termofuse" element={<BrainIQTerms />} />
        <Route path="/apps/PureTrackerVaping/termofuse" element={<PureTrackerQuitVapingTerms />} />
        <Route path="/apps/PureTrackerDrinking/termofuse" element={<PureTrackerQuitDrinkingTerms />} />
        <Route path="/apps/pupverse/termofuse" element={<PupverseTerms />} />
        <Route path="/apps/Schedula/termofuse" element={<SchedulaTerms />} />

        <Route path="/apps/whitenoise/accountremove" element={<WhiteNoiseCalmSleepAccountRemove />} />
        <Route path="/apps/qrbarcode/accountremove" element={<QRBarcodeScannerAccountRemove />} />
        <Route path="/apps/smartgps/accountremove" element={<SmartGpsCompassAccountRemove />} />
        <Route path="/apps/notespark/accountremove" element={<NoteSparkAccountRemove />} />
        <Route path="/apps/magicerace/accountremove" element={<MagicEraserAccountRemove />} />

        <Route path="/apps/seekaichat/accountremove" element={<SeekAiChatAccountRemove />} />
        <Route path="/apps/nola/accountremove" element={<NolaAiChatFriendAccountRemove />} />
        <Route path="/apps/hwsolver/accountremove" element={<AiHomeworkSolverAccountRemove />} />
        <Route path="/apps/photo_vaylt/accountremove" element={<VeilifyPhotoVaultAccountRemove />} />
        <Route path="/apps/voice_changer/accountremove" element={<VoiceChangerProAccountRemove />} />

        <Route path="/apps/colorie_counter/accountremove" element={<AiCalorieCounterAccountRemove />} />
        <Route path="/apps/invoice_maker/accountremove" element={<InvoiceMakerForContractorsAccountRemove />} />
        <Route path="/apps/smart_spy/accountremove" element={<SmartSpyDetectorAccountRemove />} />
        <Route path="/apps/collage_ai/accountremove" element={<SmartCollageAiAccountRemove />} />
        <Route path="/apps/trader_lab/accountremove" element={<TraderLabAccountRemove />} />

        <Route path="/apps/wishflow/accountremove" element={<WishFlowAccountRemove />} />
        <Route path="/apps/brainiq/accountremove" element={<BrainIQAccountRemove />} />
        <Route path="/apps/puretrackervaping/accountremove" element={<PureTrackerQuitVapingAccountRemove />} />
        <Route path="/apps/puretrackerdrinking/accountremove" element={<PureTrackerQuitDrinkingAccountRemove />} />
        <Route path="/apps/pupverse/accountremove" element={<PupverseAccountRemove />} />
        <Route path="/apps/schedula/accountremove" element={<SchedulaAccountRemove />} />

        <Route path="/apps/support" element={<SupportPage />} />
        <Route path="/apps/support/index" element={<SupportPage />} />
        <Route path="/apps/support/index.jsx" element={<SupportPage />} />
        
        <Route path="*" element={<div>Page not found</div>} />
      </Routes>
    </Layout>
  );
}

export default App;
